import { gql } from '@apollo/client';

export const QUICK_ACTION_LINE_ITEM_BY_ID = gql`
  mutation quickActionLineItemByID($lineItemId: ID!, $action: LineItemQuickAction!) {
    quickActionLineItemByID(lineItemId: $lineItemId, action: $action) {
      id
    }
  }
`;
